<template>

    <div class="layout__container">

        <div class="layout__padding-clear layout__width-80">

            <div class="layout__width-70 layout__padding-clear">
                <p class="text__align-center text__size-16 text__colour-grey">
                    Make the most of your property photography from just £2.95 per image.
                </p>
            </div>
        </div>

        <div class="layout__padding-20-0">
            <div class="colour__background-light-grey layout__width-100 layout__overflow-hidden layout__padding-40px-0">
                <div class="layout__padding-clear layout__width-80">
                    <div class="component__columns-3 text__align-center layout__border__right-1px">
                        <img class="layout__width-100px layout__padding-20-0"
                             src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/basicIcon.png">

                        <h3>Basic Photofix</h3>
                        <h3 class="text__colour-teal">£2.95</h3>
                        <h4 class="text__colour-teal">per image</h4>
                        <h4 class="layout__padding__top-10px">Allow 24hrs (Monday - Friday)</h4>
                    </div>
                    <div class="layout__width-60 layout__position-left text__align-center">
                        <div class="">
                            <div class="text__size-16 text__align-center layout__padding-40px-0 layout__padding-clear layout__width-90">
                                Our most popular Photofix. A basic retouch will drastically improve the quality of your
                                photo and bring the property to life for just £2.95 (inclusive of all basic fixes).
                            </div>


                            <div class="component__columns-4 text__align-center">
                                <div class="icon-brighten-circle text__colour-teal text__size-45 text__align-center"></div>
                                <div class="text__size-14 layout__padding-20-0 text__align-center">Brighten <br>Image
                                </div>
                            </div>
                            <div class="component__columns-4 text__align-center">
                                <div class="icon-sky-circle text__colour-teal text__size-45"></div>
                                <div class="text__size-14 layout__padding-20-0 text__align-center">Add <br>Blue Sky
                                </div>
                            </div>
                            <div class="component__columns-4 text__align-center">
                                <div class="icon-vibrance-circle text__colour-teal text__size-45"></div>
                                <div class="text__size-14 layout__padding-20-0 text__align-center">Increase <br>Vibrancy
                                </div>
                            </div>
                            <div class="component__columns-4 text__align-center">
                                <div class="icon-distortion-circle text__colour-teal text__size-45"></div>
                                <div class="text__size-14 layout__padding-20-0 text__align-center">Correct <br>Distortion
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="layout__width-100 layout__overflow-hidden layout__padding-40px-0">
                <div class="layout__padding-clear layout__width-80">
                    <div class="component__columns-3 text__align-center layout__border__right-1px">
                        <img class="layout__width-100px layout__padding-20-0"
                             src="https://rpsassets.blob.core.windows.net/rpsimages/images/photofixr/advancedIcon.png">
                        <h3>Advanced Photofix</h3>
                        <h3 class="text__colour-red">+£3.00</h3>
                        <h4 class="text__colour-red">per image</h4>
                        <h4 class="layout__padding__top-10px">Allow 48hrs (Monday - Friday)</h4>
                    </div>
                    <div class="layout__width-60 layout__position-left text__align-center">
                        <div class="">
                            <div class="text__size-16 text__align-center layout__padding-40px-0 layout__padding-clear layout__width-90">
                                Our advanced Photofix will add the finer touches to your property photography. Create
                                luscious lawns and remove unwanted cars, bins or anything else that might obscure the
                                view of the property, for just £5.95 per photofix.
                            </div>
                            <div class="component__columns-4 text__align-center">
                                &ensp;
                            </div>
                            <div class="component__columns-4 text__align-center">
                                <div class="icon-add-grass-circle text__colour-red text__size-45"></div>
                                <div class="text__size-14 layout__padding-20-0 text__align-center">Fix Patchy <br>Grass 
                                </div>
                            </div>
                            <div class="component__columns-4 text__align-center">
                                <div class="icon-remove-circle text__colour-red text__size-45"></div>
                                <div class="text__size-14 layout__padding-20-0 text__align-center">Remove <br>Object(s)
                                </div>
                            </div>
                            <div class="component__columns-4 text__align-center">
                                &ensp;
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "pricing",
        components: {
        },
        mounted() {
        },
        data() {
            return {
            }
        }
    };
</script>